export const faqs = [
    {
        category: "General",
        questions: [
            {
                q: "What is CardBox?",
                a: "CardBox is a digital identity platform that replaces paper visiting cards. It allows professionals to create a shareable 'Digital Card' and helps customers find trusted local service providers like plumbers, electricians, and designers."
            },
            {
                q: "Is CardBox free to use?",
                a: "Creating a Digital Card and searching for providers is free. After 20 eligible completed services, a provider makes a one-time ₹99 activation payment to keep receiving new booking requests."
            },
        ]
    },
    {
        category: "For Service Providers",
        questions: [
            {
                q: "How do I create my Digital Card?",
                a: "Simply click on 'Get Started', sign up with your phone number, and fill in your business details. Your card will be live instantly!"
            },
            {
                q: "How can I share my card?",
                a: "You can share your card via WhatsApp, copy your unique profile link, or show your QR code directly from your dashboard."
            },
            {
                q: "What is the 'Verified Pro' badge?",
                a: "A verification badge reflects only the checks recorded by CardBox. Verification is separate from the one-time provider activation payment and is not a guarantee of service quality."
            }
        ]
    },
    {
        category: "Activation & Support",
        questions: [
            {
                q: "Does provider activation renew?",
                a: "No. The ₹99 provider activation is a one-time payment and does not renew automatically."
            },
            {
                q: "How do I contact support?",
                a: "Use the support options available inside the CardBox app. During provider setup, Onboarding help can request a support callback."
            }
        ]
    }
];
